import {
	SET_ENABLE_CONTINUE_BTN,
	SET_DISABLE_CONTINUE_BTN
} from '../actions/types';

export default function enableDisableContinueBtn(state = false, action) {
	if (!action.error && action.payload) {
		switch (action.type) {
			case SET_ENABLE_CONTINUE_BTN:
				return action.payload;
			case SET_DISABLE_CONTINUE_BTN:
				return !action.payload;
			// no default
		}
	}

	return state;
}
